import { IntegrationModuleListItem } from 'components/Integrations/components/IntegrationModuleListItem';
import React from 'react';
import quickbooksSrc from 'images/quickbooks_logo.png';

export const QuickbooksIntegrationListItem = () => (
  <IntegrationModuleListItem iconSrc={quickbooksSrc} content="QuickBooks" />
);
